// components/PDFProvider.jsx (Alternative with html2pdf.js)
import React, { useState, useRef, useCallback } from 'react';
import QuotationPDFTemplate from '../services/QuotationPDFTemplate';
import html2pdf from 'html2pdf.js';

export const PDFContext = React.createContext(null);

export const PDFProvider = ({ children }) => {
  const [pdfData, setPdfData] = useState(null);
  const pdfContentRef = useRef(null);

  const generatePDF = useCallback(async (data) => {
    if (!data) {
      throw new Error('No data provided');
    }

    setPdfData(data);
    
    // Wait for React to render
    await new Promise(resolve => setTimeout(resolve, 300));

    try {
      const element = pdfContentRef.current;
      
      // html2pdf.js with optimized settings
      const opt = {
        margin: [0.5, 0.5, 0.5, 0.5],
        filename: `quotation_${data.quotation_number || 'download'}.pdf`,
        image: { 
          type: 'jpeg', 
          quality: 0.8  // Reduced quality for smaller size
        },
        html2canvas: { 
          scale: 1.5,    // Reduced scale
          letterRendering: false,
          logging: false,
          allowTaint: true,
          useCORS: true
        },
        jsPDF: { 
          unit: 'mm', 
          format: 'a4', 
          orientation: 'portrait',
          compress: true  // Enable compression
        }
      };

      await html2pdf().set(opt).from(element).save();
      
      setPdfData(null);
      return true;
    } catch (error) {
      // console.error('PDF gen/eration failed:', error);
      setPdfData(null);
      throw error;
    }
  }, []);

  return (
    <PDFContext.Provider value={{ generatePDF }}>
      <div style={{ 
        position: 'absolute', 
        left: '-9999px', 
        top: 0, 
        zIndex: -1,
        backgroundColor: 'white',
        width: '210mm'
      }}>
        {pdfData && (
          <QuotationPDFTemplate 
            ref={pdfContentRef} 
            data={pdfData} 
          />
        )}
      </div>
      {children}
    </PDFContext.Provider>
  );
};